import React from "react";
import { motion } from "framer-motion";
import { FaExternalLinkAlt, FaAppStoreIos } from "react-icons/fa";
import {
  sectionVariants,
  staggerContainer,
  itemVariants,
} from "../../constants/animations";
import { PROJECTS } from "./Projects.constants";

const Projects: React.FC = () => {
  return (
    <motion.section
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="py-20 px-6 bg-slate-800/30"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl font-bold mb-12 text-center gradient-text">
          Featured Projects
        </h2>
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {PROJECTS.map((project) => (
            <motion.div
              key={project.title}
              variants={itemVariants}
              whileHover={{ y: -10 }}
              className="glass rounded-2xl p-6 gradient-border group"
            >
              <div
                className={`w-14 h-14 rounded-xl bg-gradient-to-br ${project.gradientFrom} ${project.gradientTo} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}
              >
                <project.icon className="text-2xl text-white" />
              </div>
              <h3 className="text-xl font-bold mb-2 group-hover:text-blue-400 transition-colors">
                {project.title}
              </h3>
              <p className="text-slate-400 mb-4 text-sm">
                {project.description}
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                {project.technologies.map((tech) => (
                  <span
                    key={tech}
                    className="px-2 py-1 text-xs rounded-full bg-slate-700/50 text-slate-300"
                  >
                    {tech}
                  </span>
                ))}
              </div>
              <div className="text-sm text-slate-400 mb-4">
                {project.features.map((feature) => (
                  <p key={feature}>• {feature}</p>
                ))}
              </div>
              {(project.url || project.iosUrl) && (
                <div className="flex gap-4 pt-3 border-t border-slate-700/50">
                  {project.url && (
                    <a
                      href={project.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 text-sm text-blue-400 hover:text-blue-300 transition-colors"
                    >
                      <FaExternalLinkAlt className="text-xs" />
                      <span>Web</span>
                    </a>
                  )}
                  {project.iosUrl && (
                    <a
                      href={project.iosUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 text-sm text-purple-400 hover:text-purple-300 transition-colors"
                    >
                      <FaAppStoreIos className="text-lg" />
                      <span>iOS App</span>
                    </a>
                  )}
                </div>
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Projects;
